module.exports = __webpack_public_path__ + "static/img/89006B_3_R_20180429_n_LC.906dc00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89006B_3_R_20180429_n_LC.png
// module id = G0Zy
// module chunks = 0